import styled from 'styled-components';

import { PStyled } from 'approot/shared/styles/typography.style';
import { grey1, grey7 } from 'approot/shared/styles/colours.style';
import { font12 } from 'approot/shared/styles/typography.style';
import { spacing12, spacing8 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const AssignPrintOptionsText = styled(PStyled).attrs({
  colour: grey7,
  marginBottom: 0,
})`
  ${font12}
  padding: ${rem(spacing12)};
  padding-top: 0;
`;

export const AssignPrintPrimaryButton = styled(PrimaryButton)`
  ${flexCentreAlignCss}
  gap: ${rem(spacing8)};
  width: 100%;

  svg path {
    stroke: ${grey1};
  }
`;
